import React, { Component } from 'react';
import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { connect } from 'react-redux'
import { getSynth } from '../actions/synthesisActions'
import draftToHtml from 'draftjs-to-html';
import '../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class MyEditorSynthesis extends Component {
  constructor(props){
    super(props)
    this.state = {
      editorState: EditorState.createEmpty(),
      synthesis: ''
    }
  }

  componentWillMount() {
    if(this.props.value) {
      const t = convertFromHTML(this.props.value)
      if(t.contentBlocks) {
        this.setState({
          editorState: EditorState.createWithContent(ContentState.createFromBlockArray(t))
        })
      }
    }
  }

  onEditorStateChange: Function = (editorState) => {
    this.setState({
      editorState,
      synthesis: draftToHtml(convertToRaw(editorState.getCurrentContent()))
    });
    this.props.dispatch(getSynth(this.state.synthesis))
  };

  render() {
    const { editorState } = this.state;
    return (
      <div className={'border-grey'}>
        <Editor
          wrapperClassName={'border-blue-ititoca'}
          toolbarClassName={'bg-ititoca'}
          editorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
        />
        {/* <textarea disabled value={draftToHtml(convertToRaw(editorState.getCurrentContent()))} /> */}
      </div>
    );
  }
}

export default connect()(MyEditorSynthesis)



// WEBPACK FOOTER //
// ./src/components/Draft_Synthesis.js